import React from "react";
import { Header, LoadingScreen } from "../..";
import { LayoutContainer, Page } from "../../layouts/Layout";
import { CentreCol } from "../Layout";
export const FutureListPage = ({ children, title, navigation, reference, extra, back, loading, type = "table", subtitle, }) => {
    if (loading) {
        return React.createElement(LoadingScreen, null);
    }
    return (React.createElement(Page, null,
        React.createElement(Header, { title: title, navigation: navigation, reference: reference, extra: extra, back: back, usage: "portal", subtitle: subtitle }),
        React.createElement(LayoutContainer, null,
            React.createElement(CentreCol, null,
                React.createElement("div", { className: type === "grid" ? "grid grid--tiled" : "layout--table" }, children)))));
};
